var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/core-js/library/modules/_core.js
// module id = 24
// module chunks = 0